import { type ExternalUserServiceIntegration } from '../../../../../models/User'
import React from 'react'
import { useDeleteUserIntegrationMutation } from '../../../../../store/user/user'
import { Modal } from '../../../../../components/Modal/Modal'
import { Button } from '../../../../../components/Button/Button'
import { useAppDispatch } from '../../../../../store/hooks'
import { addToast } from '../../../../../store/toast/toastSlice'
import { TrackEvent, useTracking } from '../../../../../apps/professional-app/fa/common/tracking'

interface DeleteDelegatedEmailModalProps {
  accountId: string
  userId: string
  integration: ExternalUserServiceIntegration
  onHide: () => void
}

export const DeleteDelegatedEmailModal: React.FC<DeleteDelegatedEmailModalProps> = ({ accountId, userId, integration, onHide }) => {
  const dispatch = useAppDispatch()
  const [deleteUserIntegration, { isLoading: isDeletingIntegration }] = useDeleteUserIntegrationMutation()
  const { tracked } = useTracking()

  const _removeDelegatedEmailIntegration = async () => {
    if (userId && integration.id) {
      const result = await deleteUserIntegration({ accountId, payload: { userId, integrationId: integration.id } })
      if (!('error' in result)) {
        dispatch(addToast({ variant: 'success', title: 'Success', messages: ['Linked email removed'] }))
      }
      onHide()
    }
  }

  const removeDelegatedEmailIntegration = tracked(_removeDelegatedEmailIntegration, {
    eventName: TrackEvent.DELEGATED_EMAIL_REMOVE,
    eventDetails: {
      userId,
    },
  })

  const body = (
    <>
      <div className='d-flex w-100 justify-content-center mb-3'>
        <h5 className='mb-0'>Remove linked email</h5>
      </div>
      <p>
        Zocks won't be able to recognize calendar invitations from <strong>{integration.externalId}</strong> anymore.
      </p>
    </>
  )

  const footer = (
    <div className='d-flex w-100 gap-3'>
      <Button variant='secondary' className='w-50' onClick={onHide}>
        Cancel
      </Button>
      <Button variant='danger' className='w-50' onClick={removeDelegatedEmailIntegration} loading={isDeletingIntegration}>
        Remove
      </Button>
    </div>
  )

  return <Modal show onHide={onHide} header={<></>} body={body} footer={footer} />
}
